import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { TableRow, TableCell, IconButton } from "@material-ui/core";
import _ from "lodash";
import { ReactComponent as PlusRed } from "../../assets/icons/plus-circle-red.svg";
import { ReactComponent as MinusRed } from "../../assets/icons/minus-circle-red.svg";
import { ReactComponent as EditJob } from "../../assets/icons/edit.svg";
import DeleteIcon from "@material-ui/icons/Delete";
import Star from "@material-ui/icons/Star";
import StarBorder from "@material-ui/icons/StarBorder";
import { TableViewSelectionContext } from "../../context/TableViewSelectionContext";
import Moment from "moment";
import JobUtils from "../../utils/JobsUtils";
import OverflowTool from "../tooltip/OverflowTool";
import useStoreConfig from "../../hooks/useStoreConfig";
import { DashboardContext } from "../../context/DashboardContext";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { UserContext } from "../../context/UserContext";
import RequestUtils from "../../utils/RequestUtils";
import "./table.scss";
import styles from "../../styles/_export.modules.scss";
import ConfigUtils from "../../utils/ConfigUtils";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

const JobTableRow = ({ keyId, parentId, totalCount, data, headersData, isMultipleJobs, showJob, isDraft, status }) => {
  const { selected, upadateSelection } = useContext(TableViewSelectionContext);
  const { userRole, userInfo } = useContext(UserContext);
  const { showLoading, _setColumnAction, selectedColumnAction, deleteJob, updateFavoritesRequestsIds, dashboardView } = useContext(DashboardContext);
  const { ConfigStore } = useStoreConfig();
  const [isShow, setShow] = useState(false);
  isMultipleJobs = isMultipleJobs || false;

  const selectionData = (job) => {
    let selectionDataObject = {
      requestId: "",
      job: "",
      recordId: "",
      total: totalCount,
      isDraft: false,
      status: "",
      mode: showJob && !isDraft ? "job" : "request",
      jobData: {},
    };
    selectionDataObject.requestId = _.get(job, "requestSummary.requestId", _.get(job, "requestId"));
    selectionDataObject.job = _.get(job, "_id");
    selectionDataObject.recordId = isDraft ? _.get(job, "requests[0]._id") : _.get(job, "_id");
    selectionDataObject.isDraft = isDraft;
    selectionDataObject.status = _.get(job, "status");
    selectionDataObject.jobData = job;
    return selectionDataObject;
  };

  const changeRowStatus = () => {
    upadateSelection(selectionData(showJob && !isDraft ? data : data[0]));
  };

  const TIME_OF_DAY = {
    MORNING: "Morning",
    AFTERNOON: "Afternoon",
    EVENING: "Evening"
  }

  const TIME_OF_DAY_ORDER = {
    Morning: 0,
    Afternoon: 1,
    Evening: 2
  }

  const getDateTimeColor = (dueDate, dueTime) => {
    if (Moment().isAfter(dueDate, 'day')) {  // Overdue
      return styles.dueDateOverdueColor;
    } else if (Moment().isSame(dueDate, 'day')) {  // Due Today
      if (_.isNil(dueTime) || _.isEmpty(dueTime)) {
        return styles.dueDateTodayColor;
      }
      let currentTime = getTimeOfDay();
      if (TIME_OF_DAY_ORDER[currentTime] === TIME_OF_DAY_ORDER[dueTime]) {
        return styles.dueDateTodayColor;
      } else if (TIME_OF_DAY_ORDER[currentTime] < TIME_OF_DAY_ORDER[dueTime]) {
        return styles.dueDateTomorrowColor;
      } else {
        return styles.dueDateOverdueColor;
      }
    } else if (Moment().add(1, 'day').isSame(dueDate, 'day')) { // Due Tomorrow
      return styles.dueDateTomorrowColor;
    } else {
      return null;
    }
  };

  const getTimeOfDay = () => {
    let currentHour = new Date().getHours();
    if (currentHour < 12) {
      return TIME_OF_DAY.MORNING;
    } else if (currentHour < 18) {
      return TIME_OF_DAY.AFTERNOON;
    } else {
      return TIME_OF_DAY.EVENING;
    }
  }

  const renderCell = (item, cellData) => {
    const type = _.get(item, "type", "text");
    const rowData = cellData[0] ? cellData[0] : cellData;
    const draftData = _.get(cellData, "jobs", []);

    switch (type) {
      case "idType":
        //Formatting value for Job type
        const jobData = getFieldValue(item, rowData).join(" ");
        const idType = _.find(ConfigStore.jobTypeList(), ["value", jobData]);
        return _.get(idType, "label", "")
      case "fileType":
        const fileType = _.get(_.get(rowData, "processor"), "profile.description");
        return RequestUtils.getFileTypeLabel(fileType);
      case "status":
        let text = _.map(_.get(item, "fields", []), (field) => {
          //Condition added to handle the draft job status as job are inside requestEntry
          return isDraft && _.size(draftData) > 0 ? _.get(draftData[0], field, "") : _.get(rowData, field, "");
        });
        const findRole = userRole !== "requestor" || data["jobType"] === "MEDIA_REQUEST" ? "ops" : userRole;
        const findValue = _.result(_.find(ConfigStore.statuses(), { role: findRole }), "statuses");
        text =  text.join("");
        let labelValue = _.find(findValue, ["value", text]);
        labelValue = _.get(labelValue, "label", "");
        return <span>{labelValue}</span>;
      case "collapse-button":
        return showJob && !isDraft && JobUtils.statusCheck("editJob", status, userRole, _.get(data, 'jobType')) ? (
          <Link to={`/request?jobId=${_.get(rowData, "_id")}`} style={{ color: "#2C82C9" }}>
            <IconButton>
              <EditJob
                style={{ color: "#fefefe" }}
                visibility={isDraft || !JobUtils.statusCheck("editJob", status, userRole, _.get(data, 'jobType')) ? "hidden" : "visible"}
              />
            </IconButton>
          </Link>
        ) : (
          <IconButton
            id='submittedIconButton'
            disabled={isDraft || !JobUtils.statusCheck("editJob", status, userRole, _.get(data, 'jobType'))}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              //Toggle visiblity if request mode is selected
              if (!showJob) {
                setShow(!isShow);
              }
            }}
            aria-label="add an alarm">
            {!isShow ? (
              isMultipleJobs || showJob ? (
                <Link to={`/request?jobId=${_.get(rowData, "_id")}`} style={{ color: "#2C82C9" }}>
                  <EditJob
                    style={{ color: "#fefefe" }}
                    visibility={isDraft || !JobUtils.statusCheck("editJob", status, userRole, _.get(data, 'jobType')) ? "hidden" : "visible"}
                  />
                </Link>
              ) : (
                <PlusRed visibility={isDraft ? "hidden" : "visible"} />
              )
            ) : isMultipleJobs || showJob ? (
              <EditJob style={{ color: "#fefefe" }} />
            ) : (
              <MinusRed />
            )}
          </IconButton>
        );
      case "delete-draft-button":
        return !_.get(rowData, "isSubmitted", false) && _.get(rowData, "requestor.oktaUid") === _.get(userInfo, "sub") && userRole !== "adminwithreadaccess" && userRole !== "cr_api" && userRole !== "mediarequest" ? (
          <IconButton
            id='deleteDraft'
            onClick={() => {
              showLoading();
              deleteJob(_.get(rowData, "_id"));
            }}
            style={{ padding: "0px", cursor: "pointer" }}
            aria-label="delete">
            <DeleteIcon style={{ color: "#363535" }} />
          </IconButton>
        ) : _.get(rowData, "isSubmitted", true) &&
          _.has(rowData, "favorite") &&
          userRole === "requestor" &&
          _.get(rowData, "requestor.oktaUid") === _.get(userInfo, "sub") ? (
          <IconButton
            id='favourite'
            onClick={() => {
              showLoading();
              updateFavoritesRequestsIds(_.get(rowData, "favorite"), _.get(rowData, "requestId"));
            }}
            style={{ padding: "0px", cursor: "pointer" }}
            aria-label="favorite">
            {_.get(rowData, "favorite", true) ? <Star style={{ color: styles.favoriteIconColor }} /> : <StarBorder style={{ color: styles.favoriteIconColor }} />}
          </IconButton>
        ) : null;
      case "jobId":
        const jobId = _.map(_.get(item, "fields", []), (field) => {
          return JobUtils.transformJobId(_.get(rowData, field, _.get(rowData, "jobId")));
        });
        return (
          <Link onClick={() => localStorage.setItem("lastViewedJobId", _.get(rowData, "_id"))} to={"/summary?id=" + _.get(rowData, "_id")} style={{ color: "#2C82C9" }} >
            {jobId.join(" ")}
          </Link>
        );
      case "date":
        //Need to check why it shows invalid date
        const dueDate = _.map(_.get(item, "fields", []), (field) => {
          return !_.isEmpty(_.get(rowData, field)) ? Moment(_.get(rowData, field)).format("MM/DD/YYYY") : "";
        });
        return dueDate.join(" ");
      case "dateTime":
        const dateTime = _.map(_.get(item, "fields", []), (field) => {
          return (field === "dueDate" || field === "rolledUpDate") && !_.isEmpty(_.get(rowData, field))
            ? Moment(_.get(rowData, field, new Date())).format("MM/DD/YYYY")
            : _.get(rowData, field, "");
        }).join(" ");
        const dueTime = _.get(rowData, "rolledUpTime")||_.get(rowData,"dueTime");
        return <span className="dateTime" style={{ backgroundColor: getDateTimeColor(dateTime.split(" ")[0], dueTime) }}>{dateTime}</span>
      case "dateSubmitted":
        const dateSubmitted = _.map(_.get(item, "fields", []), (field) => {
          let dateSub = _.get(rowData, field, "");
          return _.isEmpty(dateSub) ? "" : Moment(dateSub).format("MM/DD/YY hh:mm A");
        });
        return dateSubmitted.join(" ");
      case "dateTimeCompleted":
        const dateTimeCompleted = _.map(_.get(item, "fields", []), (field) => {
          let dateComp = _.get(rowData, field, "");
          return !_.isEmpty(dateComp) ? Moment(dateComp).format("MM/DD/YY hh:mm A") : "";
        });
        return dateTimeCompleted.join(" ");
      case "rolledUpCompletedDate":
        const reqDateTimeCompleted = _.map(_.get(item, "fields", []), (field) => {
          let dateComp = _.get(rowData, field, "");
          return !_.isEmpty(dateComp) ? Moment(dateComp).format("MM/DD/YY hh:mm A") : "";
        });
        return reqDateTimeCompleted.join(" ");
      case "requestId":
        const requestId = getFieldValue(item, rowData);
        return (_.has(rowData, "isSubmitted") && _.get(rowData, "isSubmitted", false)) || showJob ? (
          <Link
            to={"/requestSummary?id=" + _.get(rowData, "requestSummary.requestId", _.get(rowData, "requestId"))}
            onClick={() => localStorage.setItem("lastViewedJobId", _.get(rowData, "_id"))}
            style={{ color: "#2C82C9" }}>
            {requestId.join(" ")}
          </Link>
        ) : _.get(rowData, "requestor.oktaUid") === _.get(userInfo, "sub") ? (
          <Link id='requestIdLink' to={"/request?requestId=" + _.get(rowData, "_id")} onClick={() => localStorage.setItem("lastViewedJobId", _.get(rowData, "_id"))} style={{ color: "#2C82C9" }}>

            {requestId.join(" ")}
          </Link>
        ) : (
          requestId.join(" ")
        );
      case "preAir":
        if (userRole === 'cr_api' || userRole === 'mediarequest') {
          return null;
        }
        const isPreAir = getFieldValue(item, rowData);
        return (
          <span style={{ color: "" + isPreAir === "true" ? 'rgb(239, 107, 89)' : 'inherit' }}>{"" + isPreAir === "true" ? "Yes" : "No"}</span>
        );
      default:
        let specialHandling = _.get(item, "specialHandling", false);
        let value = getFieldValue(item, rowData);
        if (specialHandling && _.get(item, "value") === "sourceType") {
          let sourceConfig = ConfigStore.sourceTypes();
          const sourceLocationFields = ConfigUtils.getSourceLocations();
          const newIdType = dashboardView === 'jobs' && _.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole) ?
           _.find(sourceLocationFields, ["value", rowData.source.sourceLocation.newLocationSubType]) : null;
          let findValueCon = _.find(sourceConfig, [
            "value",
            _.get(value[0], "sourceType") || JobUtils.getSourceType(_.get(rowData, "source")) || _.get(rowData, "sourceType"),
          ]);
          return _.get(newIdType, "label") ?? _.get(findValueCon, "label", "");
        } else {
          return value.join(" ");
        }
    }
  };

  const getFieldValue = (item, rowData) => {
    return _.map(_.get(item, "fields", []), (field) => {
      return _.get(rowData, field, "");
    });
  }

  const isSelected = (selectedRow) => {
    const requestId = _.get(selectedRow, "requestId");
    const jobsArray = _.get(selectedRow, "jobs", []);

    if (showJob && !isDraft) {
      if (requestId === _.get(data, "requestSummary.requestId") && _.includes(jobsArray, _.get(data, "_id"))) {
        return true;
      }
    } else if (isDraft) {
      if (requestId === _.get(data[0], "requestId") && _.includes(jobsArray, _.get(data[0], "_id"))) {
        return true;
      }
    } else {
      if (requestId === _.get(data[0], "requestId") && _.includes(jobsArray, _.get(data[0], "_id"))) {
        return true;
      }
    }
    return false;
  };

  const sel = () => {
    if (showJob || isDraft) {
      return isDraft ? isSelected(selected) : null;
    } else {
      return _.isEmpty(parentId) ? false : isSelected(selected);
    }
  };

  const editField = (item, value) => {
    return (
      <span
        key={"editField" + keyId + value}
        style={{
          display: "flex",
        }}>
        <span style={{ maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{<OverflowTool width={"100%"} text={value} />}</span>
        <span>
          {!_.isEmpty(value) && JobUtils.statusCheck(_.get(item, "icon.iconType"), status, userRole, _.get(data, 'jobType')) && _.get(item, "icon.icon") !== 'calendar' ? (
            isSelected(selected) && _.get(selectedColumnAction, "icon") === _.get(item, "icon.icon") ? (
              <ArrowDropUpIcon />
            ) : (
              <ArrowDropDownIcon />
            )
          ) : (
            " "
          )}
        </span>
      </span>
    );
  };

  const handler = (e, icon, selectedHandler) => {
    _setColumnAction({
      event: e.currentTarget,
      action: icon.action,
      icon: icon.icon,
      id: _.get(data, "_id"),
      selected: selectedHandler,
    });
  };

  const cursorProperty = (item) => {
    if (_.has(item, "icon") && showJob) {
      if (JobUtils.statusCheck(_.get(item, "icon.iconType"), status, userRole, _.get(data, 'jobType'))) {
        return "pointer";
      } else {
        return "not-allowed";
      }
    } else {
      return "default";
    }
  };

  return (
    <React.Fragment>
      <TableRow
        id={_.get(data, "_id")}
        key={keyId}
        className="tableRow"
        onClick={(e) => {
          //Checking
          if (showJob) {
            //Once request page changed, we will remove this
            if (!_.includes(_.get(selected, "jobs"), _.get(data, "_id"))) {
              changeRowStatus();
            }
          }
        }}
        selected={!showJob ? sel() : false}>
        {_.map(headersData, (item, index) => {
          return (
            <TableCell
              onClick={(e) => {
                if (_.has(item, "icon") && showJob && JobUtils.statusCheck(_.get(item, "icon.iconType"), status, userRole, _.get(data, 'jobType'))) {
                  let renderVal = renderCell(item, data);
                  if (_.get(item, 'icon.icon', '') === 'calendar') {
                    renderVal = _.get(data[0] ? data[0] : data, 'dueDate', '')
                  }
                  handler(e, _.get(item, "icon"), renderVal);
                }
              }}
              key={keyId + "_cell_" + index}
              className="tableCell"
              style={
                _.has(item, "width")
                  ? {
                    width: _.get(item, "width"),
                    padding: showJob ? "0px 5px" : "8px 5px",
                    cursor: cursorProperty(item),
                  }
                  : null
              }>
              {_.get(item, "type") === "collapse-button" || _.get(item, "type") === "delete-draft-button" ? (
                renderCell(item, data)
              ) : _.has(item, "icon") && showJob ? (
                editField(item, renderCell(item, data))
              ) : (
                <OverflowTool type={item.type} text={renderCell(item, data)} />
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </React.Fragment>
  );
};

JobTableRow.defaultProps = {
  selectedJobs: [],
  setSelectedJobs: () => {/*We are sending setSelectedJobs function as a default Prop*/},
  status: "",
};

export default JobTableRow;